<h1 mat-dialog-title>Ingrese el nombre de la impresora</h1>

<mat-dialog-content>
  <form [formGroup]="form" (submit)="onSave()">
    <mat-form-field appearance="fill" class="tw-flex tw-w-full">
      <mat-label>Nombre de impresora</mat-label>
      <input matInput type="text" formControlName="namePrinter" />
    </mat-form-field>
  </form>
</mat-dialog-content>

<mat-dialog-actions>
  <button mat-raised-button class="app-btn-close" mat-dialog-close>
    Cancelar
  </button>
  <button
    mat-raised-button
    class="app-btn-save"
    [disabled]="!form.valid"
    (click)="onSave()"
  >
    Guardar
  </button>
</mat-dialog-actions>
